module.exports = __webpack_public_path__ + "img/pay_finish_2x.5843b9d4.png";